import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class OrderDetails<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: string;
  /** Alias: sumPurchasePrice */
  sumPurchasePrice?: any;
  /** Alias: dbPercent */
  dbPercent?: any;
  /** Alias: netValueMainCurrency */
  netValueMainCurrency?: any;
  /** Alias: grossValueMainCurrency */
  grossValueMainCurrency?: any;

  __typename?: string;
}

const fields: FieldDefinitions<OrderDetails> = {
  id: {
    alias: 'code',
  },
  sumPurchasePrice: {
    alias: 'sumPurchasePrice',
  },
  dbPercent: {
    alias: 'dbPercent',
  },
  netValueMainCurrency: {
    alias: 'netValueMainCurrency',
  },
  grossValueMainCurrency: {
    alias: 'grossValueMainCurrency',
  },
  __typename: {
    alias: '__typename',
  },
};

export const orderDetailsEntityDefinition: EntitiyDefinition<OrderDetails> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'OrderDetails',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
